import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggingService, WizardType } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-registration-wizard-disabled-page',
  templateUrl: './registration-wizard-disabled-page.component.html',
  styleUrls: ['./registration-wizard-disabled-page.component.scss']
})
export class RegistrationWizardDisabledPageComponent implements OnInit {
  wizardType: WizardType | undefined;
  displayMessage$: Observable<string>;

  constructor(private router:Router, 
              private translate: TranslateService, 
              private logService: LoggingService) {
    this.wizardType = this.router.getCurrentNavigation()?.extras.state?.wizardType;
  }

  ngOnInit(): void {

    if( this.wizardType === undefined ){
      this.logService.warning('No wizard type found redirecting to login page...');
      this.navigateToLoginPage();
      return;
    }

    this.displayMessage$ = this.translate.stream(`fgbcl.wizard.flow.wizardType.${this.wizardType}.text`);
  }

  navigateToLoginPage(): void{
    this.router.navigate(['/login']);
  }

}
